import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { TextField } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
export default function UnitNameTextField(param) {
    let { testId } = param;
    const { control } = useFormContext();
    const { t: unitNameTexts } = useLocaleKeys('billing.unitName');
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "unitName",
        rules: requiredValidation(unitNameTexts.validation.required()),
        render: (renderProps)=>/*#__PURE__*/ _jsx(TextField, _object_spread({
                alwaysShrinkLabel: true,
                label: unitNameTexts.label(),
                testId: testId
            }, connectControllerToTextField(renderProps)))
    });
}
